export default process.env.NODE_ENV === "development"
  ? "pk_test_yfaZJGj6ahfXYphQxzeCBj2t"
  : "pk_live_Wvgl5ZflI9Y9GPEqr7jmhzur";